import { cloneVNode, computed, h, type VNode } from "vue";
import Tooltip from "../components/tooltip/Tooltip.vue";
import {
	convertDeprecatedPlacement,
	type DeprecatedPlacementProps,
	type PlacementProps,
} from "../lib/placement";

export interface ComposableTooltipProps extends PlacementProps, DeprecatedPlacementProps {
	tooltip?: string;
}

export function useTooltip(props: ComposableTooltipProps) {
	const placement = computed<PlacementProps>(() => {
		if (props.side || props.align) {
			return { side: props.side, align: props.align };
		}

		return convertDeprecatedPlacement(props.placement ?? "bottom");
	});

	const hasTooltip = computed(() => !!props.tooltip);

	function renderWithTooltip(node: VNode, attrs?: Record<string, unknown>): VNode {
		if (!hasTooltip.value) {
			return node;
		}

		return h(
			Tooltip,
			{
				tooltip: props.tooltip,
				side: placement.value.side,
				align: placement.value.align,
			},
			() => cloneVNode(node, { ...attrs })
		);
	}

	return { hasTooltip, renderWithTooltip };
}
